import Experience from "./Experience/Experience.js";
import $ from "jquery";

let experience = null;

/* document.addEventListener("DOMContentLoaded", () => {
  const experience = new Experience(document.querySelector("canvas.webgl"));
}); */

/* document.addEventListener("DOMContentLoaded", () => {
  $("#content").load("./views/configuratorRoom.html", async () => {
    $("#loader").css("display", "block");

    const canvas = document.querySelector("canvas.webgl");
    if (canvas) {
      const experience = new Experience(canvas);

      try {
        await experience.createRoom(
          "L",
          new Array(4, 1, 2, 6),
          [],
          "./textures/sol2.jpg"
        ); 
       } catch (error) {
        console.error("Erreur lors de la création de la pièce :", error);
      } finally {
        $("#loader").css("display", "none");
      }
    } else {
      console.error("Canvas introuvable dans le contenu chargé !");
      $("#loader").css("display", "none");
    }
  }); */

/**
 * Menu steps
 */
/*   const buttons = document.querySelectorAll(".buttonMenuSteps");

  buttons.forEach((button) => {
    button.addEventListener("click", (event) => {
      const page = button.getAttribute("data-page");

      if (page) {
        // Load specific page
        $("#content").load("./views/"+page);
      } else {
        console.log("Aucune page définie pour ce bouton.");
      }
    });
  });
}); */

document.addEventListener("DOMContentLoaded", () => {
  // État de l'étape actuelle (index de 0 à 3)
  let currentStep = 0;
  let stepChoose = null;

  // Définit les noms des étapes pour plus de clarté
  const steps = ["home", "choiceRoom", "shape", "configuratorRoom"];

  // Associe chaque bouton du menu à une action
  const buttons = document.querySelectorAll(".buttonMenuSteps");

  // Initialisation de la page

  loadPage(steps[currentStep]);

  // Écoute les clics sur les boutons du menu
  buttons.forEach((button) => {
    button.addEventListener("click", (e) => {
      const targetStep = e.target.dataset.page;
      handleButtonClick(targetStep);
    });
  });

  function handleButtonClick(targetStep) {
    if (targetStep === "prev") {
      // Retour à l'étape précédente
      if (currentStep === 1) {
        if (experience) {
          if (
            confirm(
              "En retournant au menu, vous perdrez toutes vos modifications.\n\nÊtes-vous certain(e) de vouloir partir ?"
            )
          ) {
            window.location.reload(); // Recharge la page si l'utilisateur confirme
          } else {
            return;
          }
        }
      }
      if (currentStep > 0) currentStep--;
    } else if (targetStep === "01") {
      if (experience) {
        if (
          confirm(
            "En retournant au menu, vous perdrez toutes vos modifications.\n\nÊtes-vous certain(e) de vouloir partir ?"
          )
        ) {
          window.location.reload(); // Recharge la page si l'utilisateur confirme
        } else {
          return;
        }
      }
      currentStep = 0; // Aller à la page "choiceRoom"
    } else if (targetStep === "02") {
      currentStep = 1; // Aller à la page de forme (shapeSquare, shapeL, shapeT)
    } else if (targetStep === "03") {
      currentStep = 2; // Aller à la page "configuratorRoom"
    }

    if (currentStep == 2 && stepChoose !== null) {
      loadPage(stepChoose);
    } else {
      loadPage(steps[currentStep]);
    }
  }

  function loadPage(pageName) {
    // On met à jour l'URL sans recharger la page
    history.pushState({ page: pageName }, "", `./${pageName}`);

    if (pageName === "configuratorRoom") {
      $("#lineMenuSteps").addClass("configuratorMenu");
      if (!experience) {
        $("#content2").load(`./views/${pageName}.html`, () => {});
      }
      updateMenuButtons();
      bindDataShapeButtons();
      $("#content").addClass("d-none");
      $("#content2").removeClass("d-none");
    } else {
      $("#lineMenuSteps").removeClass("configuratorMenu");
      // On charge la vue dans #content
      $("#content")
        .empty()
        .load(`./views/${pageName}.html`, () => {
          // On affiche le content principal et on masque le content2
          $("#content").removeClass("d-none");
          $("#content2").addClass("d-none");

          updateMenuButtons();
          bindDataShapeButtons();

          // Si on quitte la page du configurateur, on désactive les interactions
          if (experience) {
            experience.disableInteractions();
          }
        });
    }
  }

  function updateMenuButtons() {
    const menu = document.getElementById("menuSteps");
    const buttons = document.querySelectorAll(".buttonMenuSteps");

    // Réinitialise l'affichage des boutons
    buttons.forEach((button) => button.classList.add("d-none"));
    menu.classList.remove("d-none");

    if (steps[currentStep] === "home") {
      menu.classList.add("d-none");
    }

    if (steps[currentStep] === "choiceRoom") {
      activateButton("prev");
      activateButton("01");
    }

    if (steps[currentStep] === "shape") {
      activateButton("prev");
      activateButton("01");
      activateButton("02");
    }

    if (steps[currentStep] === "configuratorRoom") {
      activateButton("prev");
      activateButton("01");
      activateButton("02");
      activateButton("03");
    }

    // Fonction pour activer un bouton donné (le rendre visible)
    function activateButton(step) {
      const button = document.querySelector(
        `.buttonMenuSteps[data-page="${step}"]`
      );
      if (button) button.classList.remove("d-none");
    }
  }

  function loadConfiguration(data) {
    if (!data.room || !data.objects) {
      console.error(
        "JSON invalide. Assurez-vous qu'il contient une salle et des objets."
      );
      return;
    }

    const { shape, measures } = data.room;
    const { texturesWalls, textureFloor } = data;

    loadPage("configuratorRoom");

    waitForCanvas(measures, shape, texturesWalls, textureFloor, data);
  }

  // Sélectionne le formulaire
  function bindDataShapeButtons() {
    // btn import file config
    const btnImportFileConfig = document.getElementById(
      "btn-open-configuration"
    );

    if (btnImportFileConfig) {
      btnImportFileConfig.addEventListener("change", function (event) {
        const file = event.target.files[0];
        if (file) {
          const reader = new FileReader();
          reader.onload = function (e) {
            const json = JSON.parse(e.target.result);
            loadConfiguration(json);
          };
          reader.readAsText(file);
        }
      });
    }

    const btnConfigurator = document.getElementById("btn-enter-configurator");
    if (btnConfigurator) {
      btnConfigurator.addEventListener("click", (e) => {
        e.preventDefault();
        // Changer la page avec pushState (ceci est optionnel si vous voulez manipuler l'URL)
        const pageName = "choiceRoom";
        currentStep = 1;
        history.pushState({ page: pageName }, "", `./${pageName}`);
        loadPage(pageName); // Cette ligne peut être superflue si location.reload() recharge la page
      });
    }

    const buttons = document.querySelectorAll("[data-shape]");
    buttons.forEach((button) => {
      button.addEventListener("click", (e) => {
        const pageName = e.target.dataset.shape;
        stepChoose = pageName;
        currentStep = 2;
        history.pushState(
          { page: pageName },
          "",
          `./${e.target.dataset.shape}`
        );
        loadPage(pageName);
      });
    });

    const buttonForm = document.getElementById("sendFormRoomConfig");

    if (buttonForm) {
      buttonForm.addEventListener("click", (e) => {
        e.preventDefault();
        const shapeChoose = e.target.dataset.id;

        const inputs = document.getElementsByClassName("inputConfigRoom");

        const tabMeasuresRoom = [];
        for (let input of inputs) {
          if (!input.value) return;
          tabMeasuresRoom.push(input.value / 1000);
        }

        // orientation shape L
        if (document.querySelector('input[name="btnorientation"]:checked')) {
          const selectedRadio = document.querySelector(
            'input[name="btnorientation"]:checked'
          );
          tabMeasuresRoom.push(selectedRadio.id);
        }

        currentStep = 3;
        loadPage("configuratorRoom");
        if (experience) experience.enableInteractions();

        waitForCanvas(tabMeasuresRoom, shapeChoose);
      });
    }
  }

  /**
   * Detect when canvas is available and create Experience
   */
  function waitForCanvas(
    measuresRoom = null,
    shapeChoose = null,
    texturesWalls = [],
    textureFloor = "",
    dataObjects = null
  ) {
    if (experience) {
      experience.room.deleteWalls();
      experience.room.createWalls(measuresRoom, shapeChoose);
      experience.room.deleteFloor();
      experience.room.createFloor();
    }

    const observer = new MutationObserver((mutations) => {
      const canvas = document.querySelector("canvas.webgl");

      if (canvas) {
        observer.disconnect();

        // create new experience

        if (!experience) {
          experience = new Experience(canvas);

          experience.createRoom(
            shapeChoose,
            measuresRoom,
            texturesWalls,
            textureFloor,
            dataObjects
          );
        }

        // On masque le loader
        $("#loader").css("display", "none");
      }
    });

    // Observe les changements dans le DOM
    observer.observe(document.body, { childList: true, subtree: true });
  }

  /**
   * Reload page
   */

  /*  window.addEventListener("beforeunload", function (event) {
    event.preventDefault();
    window.confirm("Are you sure you want to submit this form?");
  }); */


});
